export default "__VITE_ASSET__DifdWY9K__"